import { environment } from "../../../environments/environment";

/**
 * Stamps the release onto a translation asset URL.
 *
 * Angular content-hashes the JS bundle, so a deploy always fetches fresh code — but
 * `assets/i18n/**.json` keeps the same URL forever. A browser or CDN still holding yesterday's
 * copy therefore pairs **new code with old translations**, and every key renamed since the last
 * deploy renders raw: the reader sees `surface.platform` where the label should be.
 *
 * That failure is invisible to the i18n audit, which compares the source against the source.
 * Both are right; the file on the wire is the stale one. Versioning the URL is what makes the
 * two move together.
 *
 * The repo already busts branding images this way (`cache-refresh.service`); translations were
 * simply never included.
 *
 * Outside a pipeline build the token is left unreplaced, and there is nothing to bust locally,
 * so the URL is returned untouched rather than carrying a literal `#{release}#`.
 */
export function i18nAssetUrl(path: string): string {
  const release: unknown = (environment as { release?: unknown }).release;
  const usable =
    typeof release === "string" && release.trim() !== "" && !release.includes("#{");

  return usable ? `${path}?v=${encodeURIComponent(release as string)}` : path;
}
